import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Restablecer_clave.css';

const VerificarEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const [estado, setEstado] = useState('cargando');
  const [mensaje, setMensaje] = useState('');
  const yaVerificado = useRef(false);

  useEffect(() => {
    if (!token) {
      setEstado('error');
      setMensaje('Enlace inv\u00E1lido. Solicita un nuevo registro.');
      return;
    }

    if (yaVerificado.current) return;
    yaVerificado.current = true;

    const verificar = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_AUTH_CREADOR_URL}/verify_email.php?token=${token}`,
          { method: 'GET', credentials: 'include' }
        );
        const data = await response.json();
        if (data.success) {
          setEstado('ok');
          setMensaje(data.message);
        } else {
          setEstado('error');
          setMensaje(data.message);
        }
      } catch (e) {
        setEstado('error');
        setMensaje('Error de conexi\u00F3n. Intenta de nuevo.');
      }
    };

    verificar();
  }, [token]);

  return (
    <div style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
      <div className="rc-wrapper" style={{flex:1}}>
        <div className="rc-container" style={{textAlign:'center'}}>
          <div className="rc-logo">Ulalaaa</div>

          {estado === 'cargando' && (
            <>
              <h2 className="rc-titulo">{'Verificando tu cuenta...'}</h2>
              <p className="rc-subtexto">{'Por favor espera un momento.'}</p>
            </>
          )}

          {estado === 'ok' && (
            <>
              <div style={{fontSize:'48px', marginBottom:'16px'}}>
                <i className="fas fa-check-circle" style={{color:'#6bcf7f'}}></i>
              </div>
              <h2 className="rc-titulo">{'�Cuenta verificada!'}</h2>
              <p className="rc-subtexto">{mensaje}</p>
              <button className="rc-btn" onClick={() => navigate('/acceso-publicar')}>
                IR AL LOGIN
              </button>
            </>
          )}

          {estado === 'error' && (
            <>
              <div style={{fontSize:'48px', marginBottom:'16px'}}>
                <i className="fas fa-times-circle" style={{color:'#ff6b6b'}}></i>
              </div>
              <h2 className="rc-titulo" style={{color:'#ff6b6b'}}>{'Error de verificaci\u00F3n'}</h2>
              <p className="rc-subtexto">{mensaje}</p>
              <button className="rc-btn" onClick={() => navigate('/registro_contenido')}>
                VOLVER AL REGISTRO
              </button>
            </>
          )}
        </div>
      </div>

      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link"><i className="fab fa-instagram"></i></a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link"><i className="fab fa-tiktok"></i></a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link"><i className="fab fa-youtube"></i></a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link"><i className="fab fa-whatsapp"></i></a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link"><i className="fab fa-telegram"></i></a>
          </div>
          <div className="home-footer-logo">
            <img src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`} alt="Ulalaaa Logo" className="home-footer-logo-img"/>
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">{'Informaci\u00F3n Legal - T\u00E9rminos y Condiciones'}</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">{'Pol\u00EDtica de Privacidad'}</a>
          </div>
        </div>
        <div className="home-footer-texto">
          {'Ulalaaa, es un sitio web exclusivo para mayores de 18 a\u00F1os, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relaci\u00F3n laboral con las personas publicadas.'}
        </div>
        <div className="home-footer-copyright">{'�2026 Ulalaaa - Todos los derechos Reservados.'}</div>
      </footer>
    </div>
  );
};

export default VerificarEmail;